/**
 * Dekodiert CSV-Bytes mit automatischer Erkennung von UTF-8 vs. Windows-1252/ISO-8859-1.
 * Deutsche ERP-/Excel-Exporte liefern häufig CP1252 ohne BOM.
 */
export function decodeCsvBytes(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  if (!bytes.length) {
    return '';
  }

  // UTF-8 BOM
  if (bytes.length >= 3 && bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf) {
    return new TextDecoder('utf-8').decode(bytes.subarray(3));
  }

  // UTF-16 LE BOM
  if (bytes.length >= 2 && bytes[0] === 0xff && bytes[1] === 0xfe) {
    return new TextDecoder('utf-16le').decode(bytes.subarray(2));
  }

  const utf8 = new TextDecoder('utf-8', { fatal: false }).decode(bytes);
  const replacementCount = countChar(utf8, '\uFFFD');

  // Ungültige UTF-8-Sequenzen → typisch für Windows-1252-Exporte
  if (replacementCount > 0) {
    return decodeLegacyGerman(bytes);
  }

  // Heuristik: echte UTF-8-Dateien enthalten selten isolierte 0x80–0x9F-Bytes,
  // in CP1252 sind das u.a. typographische Zeichen.
  if (looksLikeLegacyEncoding(bytes)) {
    const legacy = decodeLegacyGerman(bytes);
    if (countChar(legacy, '\uFFFD') < replacementCount) {
      return legacy;
    }
  }

  return utf8;
}

function decodeLegacyGerman(bytes: Uint8Array): string {
  for (const encoding of ['windows-1252', 'iso-8859-1'] as const) {
    try {
      return new TextDecoder(encoding).decode(bytes);
    } catch {
      // Browser unterstützt Encoding nicht – nächstes probieren
    }
  }
  return new TextDecoder('utf-8', { fatal: false }).decode(bytes);
}

function looksLikeLegacyEncoding(bytes: Uint8Array): boolean {
  let highBytes = 0;
  for (let i = 0; i < bytes.length; i++) {
    const b = bytes[i];
    if (b >= 0x80 && b <= 0x9f) {
      highBytes++;
    }
  }
  return highBytes > 0;
}

function countChar(text: string, char: string): number {
  let count = 0;
  for (let i = 0; i < text.length; i++) {
    if (text[i] === char) {
      count++;
    }
  }
  return count;
}
